import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCategoriesApi, fetchMainCategoriesApi } from "../api/categoriesApi";

export const loadCategories = createAsyncThunk(
  // async thunk function (= returns function [not object] that performs async operation and then dispatches action ie updates store)
  // fetches category data from server and returns it
  // async to ensure store loads before rendering app
  "cart/loadCategories",
  async () => {
    const res = await fetchCategoriesApi();
    return res;
  }
);

export const loadMainCategories = createAsyncThunk(
  // loadCategories is time consuming...so load mainCategories first, then load all and update store (progressive loading)
  "cart/loadMainCategories",
  async () => {
    const res = await fetchMainCategoriesApi();
    return res;
  }  
);  




const initialState = []; 

export const categoriesSlice = createSlice({
  name: "categories",
  initialState: [...initialState],
//   reducers: {
//   },

  //   define action for outcome of async thunk
  extraReducers: (builder) => {
    builder
      .addCase(loadCategories.fulfilled, (state, action) => {
        if (action.payload) {
          return action.payload;
        } else {
          return [...initialState];
        }
      })
      .addCase(loadCategories.rejected, (state, action) => {
        return [...initialState];
      })
      .addCase(loadMainCategories.fulfilled, (state, action) => {
        if (action.payload) {
          return action.payload;
        } else {
          return [...initialState];
        }
      })
      .addCase(loadMainCategories.rejected, (state, action) => {
        return [...initialState];
      });
  },
});

//export (reducer function + action creator + action)
// export const {} = categoriesSlice.actions;
//export reducer
export default categoriesSlice.reducer;
